import { RouteProps } from 'react-router-dom'
import { MainPage } from '../../../pages/MainPage/MainPage'
import { AppRoutes, ChildAppRoutes } from '../../lib/const/router'

export type AppRoutesProps = RouteProps & {
    authOnly?: boolean
    child?: Record<string | ChildAppRoutes, AppRoutesProps>
    roles?: any[]
}

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
    [AppRoutes.MAIN]: {
        path: '/',
        element: <MainPage />
    }
}
